import { apiService } from '../Config/api.service';

/**
 * Ouvre un PDF dans un nouvel onglet, ou le télécharge (Yros/Kavero#489).
 *
 * Même règle que les justificatifs : l'onglet s'ouvre AVANT l'appel réseau,
 * dans le geste de l'utilisateur, sans quoi il serait bloqué comme une fenêtre
 * surgissante. Si le navigateur le refuse quand même, le fichier se télécharge.
 *
 * @param {() => Promise<Blob>} lire  rend le PDF
 * @param {string} nom  nom du fichier téléchargé
 */
export async function ouvrirPdf(lire, nom) {
  const onglet = window.open('', '_blank');
  try {
    const blob = new Blob([await lire()], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    if (onglet) {
      onglet.opener = null;
      onglet.location.href = url;
      setTimeout(() => window.URL.revokeObjectURL(url), 60000);
    } else {
      window.URL.revokeObjectURL(url);
      apiService.downloadBlob(blob, nom);
    }
  } catch (erreur) {
    if (onglet) onglet.close();
    throw erreur;
  }
}

export async function telechargerPdf(lire, nom) {
  apiService.downloadBlob(new Blob([await lire()], { type: 'application/pdf' }), nom);
}
